// src/pages/Dashboard/Dashboard.tsx
import * as React from "react";
import Grid from "@mui/material/Grid";
import { useDashboard } from "../../api/dashboard/use-dashboard";
import Loader from "../../components/Loader";
import SparkCard from "./components/SparkCard";
import Title from "../../components/Title";
import { pageHelp } from "../../components/help/pageHelp";
import { useState, useEffect } from "react";

import CasesByWeekChart from "./components/CasesByWeekChart";
import CasesStatusByWeekChart from "./components/CasesStatusByWeekChart";
import TestCaseDistribution from "./components/TestCaseDistribution";
import SlopeChart from "./components/SlopeChart";
import QueueTimeMetricsChart from "./components/AvgQueueTimeChart";

export default function Dashboard() {
  const { data, isLoading, error, refetch } = useDashboard();
  const [dashboardData, setDashboardData] = useState<any>(null);

  useEffect(() => {
    if (data && data.cases && data.agents && data.suites) {
      setDashboardData(data);
    }
  }, [data]);

  if (isLoading || !dashboardData) return <Loader />;
  if (error) return <div>Error</div>;

  const sparkData1 = dashboardData.cases.sparkData?.sparkData1 || [
    59, 59, 59, 59, 59, 59, 59,
  ];
  const sparkCategories1 = dashboardData.cases.sparkData?.categories1 || [
    "Week 01",
    "Week 02",
    "Week 03",
    "Week 04",
    "Week 05",
    "Week 06",
    "Week 07",
  ];

  const sparkData2 = dashboardData.cases.sparkData?.sparkData2 || [
    0, 0, 0, 0, 0, 0, 0,
  ];
  const sparkCategories2 = dashboardData.cases.sparkData?.categories2 || [
    "Week 01",
    "Week 02",
    "Week 03",
    "Week 04",
    "Week 05",
    "Week 06",
    "Week 07",
  ];

  const sparkData3 = dashboardData.cases.sparkData?.sparkData3 || [
    0, 0, 0, 0, 0, 0, 0,
  ];
  const sparkCategories3 = dashboardData.cases.sparkData?.categories3 || [
    "Week 01",
    "Week 02",
    "Week 03",
    "Week 04",
    "Week 05",
    "Week 06",
    "Week 07",
  ];

  const sparkData4 =
    dashboardData.agents.sparkData?.sparkData4 ||
    Array(7).fill(dashboardData.agents.overview.active);
  const sparkCategories4 = dashboardData.agents.sparkData?.categories4 || [
    "Week 01",
    "Week 02",
    "Week 03",
    "Week 04",
    "Week 05",
    "Week 06",
    "Week 07",
  ];

  return (
    <>
      <Title help={pageHelp.dashboard.help} helpItems={pageHelp.dashboard.items}>
        Dashboard Overview
      </Title>
      <Grid container spacing={3} sx={{ mt: 2 }}>
        <Grid size={{ xs: 12, md: 3, sm: 6 }}>
          <SparkCard
            title="Total Cases"
            value={dashboardData.cases.overview.total}
            data={sparkData1}
            categories={sparkCategories1}
            bgColor="#2563eb"
            group="spark1"
          />
        </Grid>
        <Grid size={{ xs: 12, md: 3, sm: 6 }}>
          <SparkCard
            title="Executed Last 30 Days"
            value={dashboardData.cases.overview.executedLast30Days}
            data={sparkData2}
            categories={sparkCategories2}
            bgColor="#0f766e"
            group="spark2"
          />
        </Grid>
        <Grid size={{ xs: 12, md: 3, sm: 6 }}>
          <SparkCard
            title="In Queue"
            value={dashboardData.cases.overview.inQueueLast30Days}
            data={sparkData3}
            categories={sparkCategories3}
            bgColor="#b45309"
            group="spark3"
          />
        </Grid>
        <Grid size={{ xs: 12, md: 3, sm: 6 }}>
          <SparkCard
            title="Agents Active"
            value={dashboardData.agents.overview.active}
            data={sparkData4}
            categories={sparkCategories4}
            bgColor="#15803d"
            group="spark4"
          />
        </Grid>
      </Grid>
      <Grid container spacing={3} sx={{ mt: 3 }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <CasesByWeekChart
            data={dashboardData.cases.sparkData?.sparkData1 || []}
            categories={dashboardData.cases.sparkData?.categories1 || []}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <CasesStatusByWeekChart
            data={dashboardData.cases.weekly.status || []}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <QueueTimeMetricsChart
            data={dashboardData.cases.avgQueueTime || []}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <TestCaseDistribution
            labels={dashboardData.cases.distribution.labels || []}
            series={dashboardData.cases.distribution.series || []}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <SlopeChart
            labels={dashboardData.cases.slopeData?.categories || []}
            data1={dashboardData.cases.slopeData?.total || []}
            data2={dashboardData.cases.slopeData?.executed || []}
            label1="Total Cases"
            label2="Executed Cases"
          />
        </Grid>
      </Grid>
    </>
  );
}
